export var AppToastTypes;
(function (AppToastTypes) {
    AppToastTypes[AppToastTypes["GROUP_CREATED"] = 0] = "GROUP_CREATED";
    AppToastTypes[AppToastTypes["GROUP_JOINED"] = 1] = "GROUP_JOINED";
    AppToastTypes[AppToastTypes["GROUP_REQUEST_TO_JOIN"] = 2] = "GROUP_REQUEST_TO_JOIN";
    AppToastTypes[AppToastTypes["GROUP_LEFT"] = 3] = "GROUP_LEFT";
    AppToastTypes[AppToastTypes["GROUP_CREATED_IN_PENDING_STATE"] = 4] = "GROUP_CREATED_IN_PENDING_STATE";
    AppToastTypes[AppToastTypes["GROUP_APPROVED"] = 5] = "GROUP_APPROVED";
    AppToastTypes[AppToastTypes["GROUP_DECLINED"] = 6] = "GROUP_DECLINED";
    AppToastTypes[AppToastTypes["GROUP_CANCELLED"] = 7] = "GROUP_CANCELLED";
    AppToastTypes[AppToastTypes["GROUP_DELETED"] = 8] = "GROUP_DELETED";
    AppToastTypes[AppToastTypes["MEMBERS_ADDED"] = 9] = "MEMBERS_ADDED";
    AppToastTypes[AppToastTypes["GROUP_LOGO_UPDATED"] = 10] = "GROUP_LOGO_UPDATED";
})(AppToastTypes || (AppToastTypes = {}));
export var APP_TOAST_EVENT = 'appToastEvent';
//# sourceMappingURL=types.js.map